import useComet from "./useComet";

const DEFAULT_VALUE = {};

function useCreditBalances(saleUserId) {
  return useComet("creditBalances", saleUserId, undefined, DEFAULT_VALUE);
}

export { useCreditBalances as default };
